import React from 'react'
import styled from 'styled-components'

function Section({ title, description, leftBtnText, rightBtnText, backgroundImg }) {
    return (
        <Wrap bgImage={backgroundImg}>
            <ItemText>
                <h1>{ title }</h1>
                <p>{ description }</p>
            </ItemText>
            <Buttons>
            <ButtonGroup>
                <LeftButton>
                    { leftBtnText }
                </LeftButton>
                {rightBtnText &&
                    <RightButton>
                    { rightBtnText }
                    </RightButton>
                }
            </ButtonGroup>
            <DownArrow src="/images/down-arrow-blk.svg" />
            </Buttons>
        </Wrap>
    )
}

export default Section

const Wrap = styled.div`
    width: 100vw;
    height: 100vh;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background-image: ${props => `url("/images/${props.bgImage}")` }
`

const ItemText = styled.div`
    padding-top: 15vh;
    text-align: center;
    h1 {
        padding-top: 10px;
        margin-bottom: -20px;
	    animation: slide-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s both;
    }
    p {
        margin-top: 10px;
        animation: text-focus-in 0.25s cubic-bezier(0.550, 0.085, 0.680, 0.530) 1s both;
    }
`
const ButtonGroup = styled.div`
    display: flex;
    margin-bottom: 30px;
    @media (max-width: 768px) {
        flex-direction: column;
        margin-bottom: 60px;
    }
`

const LeftButton = styled.div`
    background-color: rgba(23, 26, 32, 0.8);
    height: 40px;
    width: 256px;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    opacity: 0.65;
    text-transform: uppercase;
    font-size: 12px;
    cursor: pointer;
    margin: 8px;
    animation: leftButton ease 1.7s forwards;
`
const RightButton = styled.div`
    background-color: white;
    height: 40px;
    width: 256px;
    opacity: 0.65;
    color: black;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    text-transform: uppercase;
    font-size: 12px;
    cursor: pointer;
    margin: 8px;
    animation: rightButton ease 1.7s forwards;
`

const DownArrow = styled.img`
    margin-top: 20px;
    height: 40px;
    animation: animateDown infinite 1.5s;
    overflow-x: hidden;
    padding-bottom: 15px;
`

const Buttons = styled.div`
`